module.exports = __webpack_public_path__ + "static/card4-a7d89fc133c32c0afb2a76825fe6d7a9.png";